import { getBasePath } from '../../utils/config';
import * as commercialAgentType from 'api/endpoints/commercialAgent/commercialAgent.response.interface';

export const getCommercialAgentsAPI = async ({
  tenantId,
  token,
}: {
  tenantId: string;
  token: string;
}): Promise<commercialAgentType.IgetCommercialAgentsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/comercial_agent_profile/agents?tenant_id=${tenantId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const createCommercialAgentAPI = async ({
  tenantId,
  agent,
  token,
}: {
  tenantId: string;
  agent: commercialAgentType.IcreateCommercialAgentAPIBody;
  token: string;
}): Promise<commercialAgentType.IcreateCommercialAgentAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      tenant_id: tenantId,
      agent,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/comercial_agent_profile/new_agent`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const updateCommercialAgentAPI = async ({
  commercialAgentId,
  agent,
  token,
}: {
  commercialAgentId: string;
  agent: Partial<commercialAgentType.IcreateCommercialAgentAPIBody>;
  token: string;
}): Promise<commercialAgentType.IupdateCommercialAgentAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: commercialAgentId,
      update: agent,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/comercial_agent_profile/update_agent`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const assignCommercialAgentAPI = async ({
  commercialAgentId,
  clientAliasId,
  token,
}: {
  commercialAgentId: string;
  clientAliasId: string;
  token: string;
}): Promise<commercialAgentType.IassignCommercialAgentAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      comercial_agent_id: commercialAgentId,
      client_alias_id: clientAliasId,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/comercial_agent_profile/assign_agent`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const unassignCommercialAgentAPI = async ({
  comercialAgentClientAliasesId,
  token,
}: {
  comercialAgentClientAliasesId: string;
  token: string;
}): Promise<commercialAgentType.IunassignCommercialAgentAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/comercial_agent_profile/unassign?id=${comercialAgentClientAliasesId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const deleteCommercialAgentAPI = async ({
  commercialAgentId,
  token,
}: {
  commercialAgentId: string;
  token: string;
}): Promise<commercialAgentType.IdeleteCommercialAgentAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/comercial_agent_profile/delete_agent?agent_id=${commercialAgentId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};
